module.exports = __webpack_public_path__ + "static/media/alert-warning.ca581506.svg";